import React from 'react';
import { motion } from 'framer-motion';
import { Droplets, Disc, Gauge, Cog, Thermometer, Wrench, ShieldCheck } from 'lucide-react';
const services = [{
  icon: Droplets,
  title: 'Oil & Fluids',
  description: 'Premium synthetic oils and factory-approved fluids to keep your high-performance engine running smoothly.'
}, {
  icon: Disc,
  title: 'Brakes & Alignment',
  description: 'Precision brake service and laser alignment for optimal handling and safety on any road surface.'
}, {
  icon: Gauge,
  title: 'Engine Repair',
  description: 'Expert diagnostics and repair for complex European engines, from minor tune-ups to major overhauls.'
}, {
  icon: Cog,
  title: 'Transmission',
  description: 'Complete transmission service including fluid changes, clutch replacement, and rebuilding.'
}, {
  icon: Thermometer,
  title: 'HVAC & Electrical',
  description: 'Advanced electrical diagnostics and climate control repair to ensure comfort and reliability.'
}, {
  icon: Wrench,
  title: 'Scheduled Maintenance',
  description: 'Factory-scheduled service intervals to maintain your warranty and vehicle value.'
}];
export function ServicesGrid() {
  return <section id="services" className="py-24 bg-[#1a1a1a] relative overflow-hidden" data-id="element-166">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5 pointer-events-none" data-id="element-167">
        <div className="absolute inset-0 bg-[radial-gradient(#ffffff_1px,transparent_1px)] [background-size:16px_16px]" data-id="element-168" />
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-169">
        <div className="text-center mb-16" data-id="element-170">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-171">
            Our Premium Services
          </h2>
          <div className="w-20 h-1 bg-[#c41e3a] mx-auto mb-6" data-id="element-172" />
          <p className="text-gray-400 max-w-2xl mx-auto text-lg" data-id="element-173">
            We provide comprehensive care for your vehicle using
            state-of-the-art diagnostic equipment and genuine parts.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-174">
          {services.map((service, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="group relative bg-[#252525] p-8 rounded-sm border border-white/5 hover:border-[#c41e3a]/50 transition-all duration-300 hover:-translate-y-1" data-id="element-175">
              <div className="absolute top-0 left-0 w-full h-1 bg-[#c41e3a] transform scale-x-0 group-hover:scale-x-100 transition-transform duration-300 origin-left" data-id="element-176" />

              <div className="w-14 h-14 bg-[#1a1a1a] rounded-full flex items-center justify-center mb-6 border border-white/10 group-hover:border-[#c41e3a] transition-colors" data-id="element-177">
                <service.icon className="w-7 h-7 text-white group-hover:text-[#c41e3a] transition-colors" data-id="element-178" />
              </div>

              <h3 className="text-xl font-bold text-white mb-3" data-id="element-179">
                {service.title}
              </h3>
              <p className="text-gray-400 leading-relaxed group-hover:text-gray-300 transition-colors" data-id="element-180">
                {service.description}
              </p>
            </motion.div>)}
        </div>

        <div className="mt-16 flex justify-center" data-id="element-181">
          <div className="inline-flex items-center gap-3 px-6 py-3 bg-[#d4af37]/10 border border-[#d4af37]/30 rounded-full" data-id="element-182">
            <ShieldCheck className="w-5 h-5 text-[#d4af37]" data-id="element-183" />
            <span className="text-[#d4af37] font-semibold tracking-wide uppercase text-sm" data-id="element-184">
              24-Month / 24,000-Mile Nationwide Warranty
            </span>
          </div>
        </div>
      </div>
    </section>;
}